// module imports
import { summary, svgList } from './Summary'

const summaryList = (sessionList = [], isConnected = true, parked = []) => {
  const list = []

  if (sessionList.length) {
    // track all ids
    const idsList = []

    // build list
    sessionList
      .filter((session) => session && !!session.connected === isConnected)
      .forEach((session) => {
        const info = summary(session, isConnected)

        idsList.push(info.id)

        list.push(info)
      })

    // update svgList with overlap of ids
    svgList.splice(
      0,
      svgList.length,
      ...svgList.filter((id) => idsList.includes(id)),
    )
  } else {
    svgList.splice(0, svgList.length)
  }

  return [...list, ...parked.map((park) => park.summary)]
}

export default summaryList
